import vue from '@/business/main'
import Bussiness from 'Utils/business'

/**
 * 签证正常单操作方法
 * @param {Object: VisaOrder} detail 签证订单详
 */

export default {
  /**
   * 取消
   */
  async cancel (detail) {
    await vue.$dialog.confirm({
      message: '确认取消吗？',
    }).then(async () => {
      try {
        await vue.$api['VisaOrder/Cancel']({orderId: detail.id})
        return vue.$dialog.alert({ message: '取消订单成功' })
      } catch (res) {
        return res
      }
    })
  },
  /**
   * 送审
   */
  approval (detail) {
    detail.orderType = $dict.ORDER_TYPE.visa
    Bussiness.ApprovalSend(detail)
  },
  async revertApproval (detail) {
    detail.orderType = $dict.ORDER_TYPE.visa
    await Bussiness.ApprovalRevert(detail)
  },

}